import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { NotificationsAccessNotifierScope } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type Notifier from 'modules/notifications/store/models/Notifier'
import type UserPreference from 'modules/notifications/store/models/UserPreference'

import { Category } from './_Category'
import { useComputedPreferences } from './hooks/useComputedPreferences'

interface Props {
  notifiers: Notifier[]
  preferences: UserPreference[]
  notifierScopes: NotificationsAccessNotifierScope[]
  search: string
  onPreferenceUpdated: (preference: UserPreference, newValue: boolean) => Promise<void>
  onScopeUpdated: (notifier: string, newValue: string) => Promise<void>
}

export const PreferencesList = observer(
  ({
    notifiers,
    preferences,
    notifierScopes,
    search,
    onPreferenceUpdated,
    onScopeUpdated,
  }: Props) => {
    const computedPreferences = useComputedPreferences(
      notifiers,
      preferences,
      notifierScopes,
      search
    ).get()

    return (
      <Box width="full">
        {Object.values(computedPreferences.categories)
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((category) => (
            <Category
              key={category.identifier}
              category={category}
              onPreferenceUpdated={onPreferenceUpdated}
              onScopeUpdated={onScopeUpdated}
            />
          ))}
      </Box>
    )
  }
)
